import React, { useState } from 'react'
import { ERROR, SET_SUCCESS } from '../../store/types';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import TextField from '../../components/elements/form/TextField';
import PasswordField from '../../components/elements/form/PasswordField';
import FormButton from '../../components/elements/form/FormButton';
import ArrowIcon from '../../components/elements/icons/ArrowIcon';
import AutocompleteSelect from '../../components/elements/form/AutocompleteSelect';
import { Nationalities } from '../../assets/static/nationalities';
import { StatesLgas } from '../../assets/static/stateslgas';
import { parseNigerianStates, slugify } from '../../utils';
import DateField from '../../components/elements/form/DateField';
import CheckIcon from '../../components/elements/icons/CheckIcon';
import CheckBadgeIcon from '../../components/elements/icons/CheckBadgeIcon';
import Countdown from '../../components/elements/Countdown';
import moment from 'moment';
import RadioGroup from '../../components/elements/form/RadioGroup';
import InlinePreloader from '../../components/elements/InlinePreloader';


const Signup = () => {
    const dispatch = useDispatch()

    const [processing, setProcessing] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [userPayload, setUserPayload] = useState({});
    const [userOrigin, setUserOrigin] = useState({});
    const [userAddress, setUserAddress] = useState({});
    const [userEmployment, setUserEmployment] = useState({});
    const [signupComplete, setSignupComplete] = useState(false);

    const [validationErrors, setValidationErrors] = useState({});
    const validateStep1Form = () => {
        let errors = {}
        if(!userPayload.email || userPayload.email === '') {
            errors.email = true
        }
        if(!userPayload.password || userPayload.password === '') {
            errors.password = true
        }
        setValidationErrors(errors)

        return errors
    }

    const validateStep2Form = () => {
        let errors = {}
        if(!userPayload.firstName || userPayload.firstName === '') {
            errors.firstName = true
        }
        if(!userPayload.lastName || userPayload.lastName === '') {
            errors.lastName = true
        }
        if(!userPayload.dob || userPayload.dob === '') {
            errors.dob = true
        }
        if(!userPayload.gender || userPayload.gender === '') {
            errors.gender = true
        }
        if(!userOrigin.nationality || userOrigin.nationality === '') {
            errors.nationality = true
        }
        if(!userOrigin.state || userOrigin.state === '') {
            errors.state = true
        }
        if(!userOrigin.lga || userOrigin.lga === '') {
            errors.lga = true
        }
        setValidationErrors(errors)

        return errors
    }

    const validateStep3Form = () => {
        let errors = {}
        if(!userPayload.phone || userPayload.phone === '') {
            errors.phone = true
        }
        if(!userAddress.address || userAddress.address === '') {
            errors.address = true
        }
        if(!userAddress.city || userAddress.city === '') {
            errors.addressCity = true
        }
        if(!userAddress.state || userAddress.state === '') {
            errors.addressState = true
        }
        console.log(errors)
        setValidationErrors(errors)

        return errors
    }

    const validateStep4Form = () => {
        let errors = {}
        if(!userPayload.occupation || userPayload.occupation === '') {
            errors.occupation = true
        }
        if(!userEmployment.organization || userEmployment.organization === '') {
            errors.organization = true
        }
        if(!userEmployment.address || userEmployment.address === '') {
            errors.workAddress = true
        }
        if(!userEmployment.city || userEmployment.city === '') {
            errors.workCity = true
        }
        if(!userEmployment.state || userEmployment.state === '') {
            errors.workState = true
        }
        setValidationErrors(errors)

        return errors
    }

    const completeStepOne = () => {
        if (Object.values(validateStep1Form()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        setActiveStep(2)
    }

    const completeStepTwo = () => {
        if (Object.values(validateStep2Form()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        setActiveStep(3)
    }

    const completeStepThree = () => {
        if (Object.values(validateStep3Form()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            console.log(validationErrors)
            return
        }
        console.log('completed step 3...')
        setActiveStep(4)
    }
    
    const signup = async () => {
        const headers = {
            'Content-Type': 'application/json'
        }

        if (Object.values(validateStep4Form()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        setProcessing(true)

        const requestPayload = {
            ...userPayload, 
            ...{
                employment: userEmployment,
                address: userAddress,
                origin: userOrigin,
                frontendUrl: window.location.origin
            }
        }

        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/onboarding/parent/signup`, requestPayload, { headers })            

            setProcessing(false)
            setSignupComplete(true)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const [activeLgas, setActiveLgas] = useState([])
    const [lgasEnabled, setLgasEnabled] = useState(false)

    const selectState = (selectedState) => {
        setLgasEnabled(false)
        setActiveLgas(StatesLgas.find((state)=>{
            return state.stateSlug === slugify(selectedState.label)
        }).lgas)

        setTimeout(() => {
            setLgasEnabled(true)
        }, 50);

        setUserOrigin({...userOrigin, ...{state: selectedState.label}})
    }

    const [addressLgasEnabled, setAddressLgasEnabled] = useState(false);
    const [activeAddressLgas, setActiveAddressLgas] = useState(null);
    const selectAddressState = (selectedState) => {
        setAddressLgasEnabled(false)
        setActiveAddressLgas(StatesLgas.find((state)=>{
            return state.stateSlug === slugify(selectedState.label)
        }).lgas)

        setTimeout(() => {
            setAddressLgasEnabled(true)
        }, 50);

        setUserAddress({...userAddress, ...{state: selectedState.label}})
    }

    const [workLgasEnabled, setWorkLgasEnabled] = useState(false);
    const [activeWorkLgas, setActiveWorkLgas] = useState(null);
    const selectEmploymentState = (selectedState) => {
        setWorkLgasEnabled(false)
        setActiveWorkLgas(StatesLgas.find((state)=>{
            return state.stateSlug === slugify(selectedState.label)
        }).lgas)

        setTimeout(() => {
            setWorkLgasEnabled(true)
        }, 50);

        setUserEmployment({...userEmployment, ...{state: selectedState.label}})
    }

    const [counted, setCounted] = useState(false);

    const resendConfirmationEmail = async () => {
        const headers = {
            'Content-Type': 'application/json'
        }

        setProcessing(true)

        const requestPayload = {
            email: userPayload.email,
            frontendUrl: window.location.origin
        }

        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/onboarding/email-confirmation/resend`, requestPayload, { headers })            

            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: 'Email confirmation resent successfully!'
            })
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }
    
    return (
        <div className='w-full bg-vcm-light-purple bg-opacity-10 min-h-screen h-inherit py-12'>
            <div className="w-[90%] lg:w-1/2 2xl:w-4/12 mx-auto rounded-[8px] bg-white p-8 transition duration-200">
                    <h1 className="font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>
                    <p>Sign up as a parent</p>
                    {!signupComplete && <p className="text-sm">Please provide your data in the forms below to create an account. <br />
                    Note: All fields marked <span className='text-red-500'>*</span> are compulsory
                    </p>}

                    <div className='border-b w-full border-gray-300 mt-8 mb-4' />
                    {!signupComplete && <span>
                        {activeStep === 1 && 
                            <div>
                                <p className="text-sm text-primary mb-1 tracking-[0.2em] uppercase">step 1 of 4: <span className="tracking-normal text-sm">Account Information</span></p>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Email address" 
                                        fieldId="email" 
                                        requiredField={true}
                                        inputType="text" 
                                        preloadValue={userPayload.email || ''}
                                        hasError={validationErrors && validationErrors.email} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{email: value}})}}
                                    />
                                    <label className='text-gray-400 text-xs block mt-2'>Please use a valid and active email address as we will be sending important information to you via this email.</label>
                                </div>
                                
                                <div className='mt-4'>
                                    <PasswordField
                                        inputLabel="Password" 
                                        fieldId="password" 
                                        requiredField={true}
                                        inputType="password" 
                                        preloadValue={userPayload.password || ''}
                                        hasError={validationErrors && validationErrors.password} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{password: value}})}}
                                    />
                                </div>
                                
                                <div className='mt-8'>
                                    <FormButton buttonLabel={
                                        <span className='flex items-center justify-center gap-x-4'>
                                            Continue <ArrowIcon className={`w-5 h-5`}/>
                                        </span>
                                    } buttonAction={()=>{completeStepOne()}} processing={processing} />
                                </div>
                            </div>
                        }
                        {activeStep === 2 && 
                            <div>
                                <p className="text-sm text-primary mb-1 tracking-[0.2em] uppercase">step 2 of 4: <span className="tracking-normal text-sm">Personal Information</span></p>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Your first name" 
                                        fieldId="first-name" 
                                        requiredField={true}
                                        inputType="text" 
                                        preloadValue={userPayload.firstName || ''}
                                        hasError={validationErrors && validationErrors.firstName} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{firstName: value}})}}
                                    />
                                </div>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Your last name" 
                                        fieldId="last-nem" 
                                        requiredField={true}
                                        inputType="text" 
                                        preloadValue={userPayload.lastName || ''}
                                        hasError={validationErrors && validationErrors.lastName} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{lastName: value}})}}
                                    />
                                </div>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Other names" 
                                        fieldId="email" 
                                        inputType="text" 
                                        preloadValue={userPayload.otherNames || ''}
                                        hasError={validationErrors && validationErrors.email} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{otherNames: value}})}}
                                    />
                                </div>
                                <div className='mt-4'>
                                <RadioGroup 
                                    items={[
                                        {
                                            label: 'Female',
                                            value: 'FEMALE'
                                        },
                                        {
                                            label: 'Male',
                                            value: 'MALE'
                                        }
                                    ]} 
                                    preSelectedIndex={''}
                                    inputLabel={'Gender'}
                                    requiredField={true}
                                    returnSelected={(value) => {setUserPayload({...userPayload, ...{gender: value.value}})}} 
                                    hasError={validationErrors && validationErrors.gender}  
                                    titleField='label'
                                />
                                </div>
                                <div className='mt-4'>
                                    <DateField
                                        inputLabel="Date of Birth" 
                                        fieldId="dob" 
                                        requiredField={true}
                                        inputType="text" 
                                        preloadValue={userPayload.dob || ''}
                                        hasError={validationErrors && validationErrors.dob} 
                                        returnFieldValue={(value)=>{
                                            const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                                            setUserPayload({...userPayload, ...{dob: formattedDate}})}}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    <AutocompleteSelect
                                        selectOptions = {Nationalities}
                                        requiredField={true}
                                        inputLabel = "Citizenship"
                                        titleField = "name"
                                        displayImage = {true}
                                        imageField = "image"
                                        fieldId = "citizenship"
                                        preSelected={userOrigin.nationality && userOrigin.nationality !== '' ? userOrigin.nationality : ''}
                                        preSelectedLabel='code'
                                        hasError = {validationErrors && validationErrors.nationality}
                                        returnFieldValue={(value)=>{setUserOrigin({...userOrigin, ...{
                                            countryCode: value.code,
                                            nationality: value.name
                                        }})}}
                                        disabled={false}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    {userOrigin.countryCode === 'NG' ?
                                        <AutocompleteSelect
                                            selectOptions = {parseNigerianStates()}
                                            inputLabel = "State"
                                            requiredField={true}
                                            titleField = "label"
                                            displayImage = {false}
                                            imageField = ""
                                            fieldId = "State"
                                            preSelected={userOrigin.state || ''}
                                            preSelectedLabel='value'
                                            hasError = {validationErrors && validationErrors.state}
                                            returnFieldValue={(value)=>{selectState(value)}}
                                        />
                                    :
                                        <TextField 
                                            inputType="text" 
                                            fieldId="state"
                                            requiredField={true}
                                            inputLabel="State" 
                                            hasError={validationErrors && validationErrors.state === true} 
                                            preloadValue={userOrigin.state || ''}
                                            // disabled={true}
                                            disabled={false}
                                            returnFieldValue={(value)=>{setUserOrigin({...userOrigin, ...{state: value}})}}
                                        />

                                    }
                                </div>

                                <div className='w-full mt-4'>
                                    {userOrigin.countryCode === 'NG' && lgasEnabled === true ?
                                        <AutocompleteSelect
                                            selectOptions = {activeLgas}
                                            inputLabel = "Lga/City"
                                            titleField = ""
                                            displayImage = {false}
                                            imageField = ""
                                            disabled={!lgasEnabled}
                                            fieldId = "userLga"
                                            preSelected={userOrigin.city || ''}
                                            requiredField={true}
                                            preSelectedLabel='value'
                                            hasError = {validationErrors && validationErrors.lga}
                                            returnFieldValue={(value)=>{
                                                console.log('selected value:: ', value)
                                                setUserOrigin({...userOrigin, ...{ lga: value }})}}
                                        />
                                    :
                                        <TextField 
                                            inputType="text" 
                                            fieldId="city"
                                            inputLabel="Lga/City" 
                                            hasError={validationErrors && validationErrors.lga === true} 
                                            preloadValue={userOrigin.lga || ''}
                                            // disabled={true}
                                            requiredField={true}
                                            disabled={false}
                                            returnFieldValue={(value)=>{setUserOrigin({...userOrigin, ...{ lga: value }})}}
                                        />
                                    }
                                </div>
                                
                                <div className='mt-8'>
                                    <button onClick={()=>{setActiveStep(1)}} className='flex items-center gap-x-2 text-gray-500 hover:text-vcm-purple transition duration-200 mb-3 text-sm'>
                                        <ArrowIcon className={`w-4 h-4 rotate-180`} />
                                        Previous step
                                    </button>
                                    <FormButton buttonLabel={
                                        <span className='flex items-center justify-center gap-x-4'>
                                            Continue <ArrowIcon className={`w-5 h-5`}/>
                                        </span>
                                    } buttonAction={()=>{completeStepTwo()}} processing={processing} />
                                </div>
                            </div>
                        }
                        {activeStep === 3 && 
                            <div>
                                <p className="text-sm text-primary mb-1 tracking-[0.2em] uppercase">step 3 of 4: <span className="tracking-normal text-sm">Contact Information</span></p>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Phone number" 
                                        fieldId="phone-1" 
                                        inputType="text" 
                                        requiredField={true}
                                        preloadValue={userPayload.phone || ''}
                                        hasError={validationErrors && validationErrors.phone} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{phone: value}})}}
                                    />
                                </div>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Alternate Phone number" 
                                        fieldId="phone-1" 
                                        inputType="text" 
                                        preloadValue={userPayload.altPhone || ''}
                                        hasError={false} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{altPhone: value}})}}
                                    />
                                </div>

                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Home Address" 
                                        fieldId="address-1" 
                                        inputType="text" 
                                        requiredField={true}
                                        preloadValue={userAddress.address || ''}
                                        hasError={validationErrors && validationErrors.address} 
                                        returnFieldValue={(value)=>{setUserAddress({...userAddress, ...{address: value}})}}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    <AutocompleteSelect
                                        selectOptions = {parseNigerianStates()}
                                        inputLabel = "State"
                                        titleField = "label"
                                        displayImage = {false}
                                        imageField = ""
                                        fieldId = "State"
                                        preSelected={userAddress.state || ''}
                                        preSelectedLabel='value'
                                        requiredField={true}
                                        hasError = {validationErrors && validationErrors.addressState}
                                        returnFieldValue={(value)=>{selectAddressState(value)}}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    {addressLgasEnabled === true ?
                                        <AutocompleteSelect
                                            selectOptions = {activeAddressLgas}
                                            inputLabel = "City"
                                            titleField = ""
                                            displayImage = {false}
                                            imageField = ""
                                            disabled={!addressLgasEnabled}
                                            fieldId = "address-city"
                                            preSelected={userAddress.city || ''}
                                            preSelectedLabel='value'
                                            requiredField={true}
                                            hasError = {validationErrors && validationErrors.addressCity}
                                            returnFieldValue={(value)=>{setUserAddress({...userAddress, ...{city: value}})}}
                                        />
                                    :
                                        <TextField 
                                            inputType="text" 
                                            fieldId="address-city-txt"
                                            inputLabel="City" 
                                            hasError={validationErrors && validationErrors.addressCity === true} 
                                            preloadValue={userAddress.city || ''}
                                            disabled={false}
                                            requiredField={true}
                                            returnFieldValue={(value)=>{setUserAddress({...userAddress, ...{city: value}})}}
                                        />
                                    }
                                </div>
                                
                                <div className='mt-8'>
                                    <button onClick={()=>{setActiveStep(2)}} className='flex items-center gap-x-2 text-gray-500 hover:text-vcm-purple transition duration-200 mb-3 text-sm'>
                                        <ArrowIcon className={`w-4 h-4 rotate-180`} />
                                        Previous step
                                    </button>
                                    <FormButton buttonLabel={
                                        <span className='flex items-center justify-center gap-x-4'>
                                            Continue <ArrowIcon className={`w-5 h-5`}/>
                                        </span>
                                    } buttonAction={()=>{completeStepThree()}} processing={processing} />
                                </div>
                            </div>
                        }
                        {activeStep === 4 && 
                            <div>
                                <p className="text-sm text-primary mb-1 tracking-[0.2em] uppercase">step 4 of 4: <span className="tracking-normal text-sm">Employment Information</span></p>
                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Occupation" 
                                        fieldId="occupation" 
                                        inputType="text" 
                                        requiredField={true}
                                        preloadValue={userPayload.occupation || ''}
                                        hasError={validationErrors && validationErrors.occupation} 
                                        returnFieldValue={(value)=>{setUserPayload({...userPayload, ...{occupation: value}})}}
                                    />
                                </div>

                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Place of Employment" 
                                        fieldId="organization" 
                                        inputType="text" 
                                        requiredField={true}
                                        preloadValue={userEmployment.organization || ''}
                                        hasError={validationErrors && validationErrors.organization} 
                                        returnFieldValue={(value)=>{setUserEmployment({...userEmployment, ...{organization: value}})}}
                                    />
                                </div>

                                <div className='mt-4'>
                                    <TextField
                                        inputLabel="Work Address" 
                                        fieldId="w-address-1" 
                                        inputType="text" 
                                        requiredField={true}
                                        preloadValue={userEmployment.address || ''}
                                        hasError={validationErrors && validationErrors.workAddress} 
                                        returnFieldValue={(value)=>{setUserEmployment({...userEmployment, ...{address: value}})}}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    <AutocompleteSelect
                                        selectOptions = {parseNigerianStates()}
                                        inputLabel = "State"
                                        titleField = "label"
                                        displayImage = {false}
                                        imageField = ""
                                        fieldId = "State"
                                        preSelected={userEmployment.state || ''}
                                        requiredField={true}
                                        preSelectedLabel='value'
                                        hasError = {validationErrors && validationErrors.workState}
                                        returnFieldValue={(value)=>{selectEmploymentState(value)}}
                                    />
                                </div>

                                <div className='w-full mt-4'>
                                    {workLgasEnabled === true ?
                                        <AutocompleteSelect
                                            selectOptions = {activeWorkLgas}
                                            inputLabel = "City"
                                            titleField = ""
                                            displayImage = {false}
                                            imageField = ""
                                            disabled={!workLgasEnabled}
                                            fieldId = "businessCity"
                                            preSelected={userEmployment.city || ''}
                                            preSelectedLabel='value'
                                            requiredField={true}
                                            hasError = {validationErrors && validationErrors.workCity}
                                            returnFieldValue={(value)=>{setUserEmployment({...userEmployment, ...{city: value}})}}
                                        />
                                    :
                                        <TextField 
                                            inputType="text" 
                                            fieldId="city"
                                            inputLabel="City" 
                                            hasError={validationErrors && validationErrors.workCity === true} 
                                            preloadValue={userEmployment.city || ''}
                                            requiredField={true}
                                            disabled={false}
                                            returnFieldValue={(value)=>{setUserEmployment({...userEmployment, ...{city: value}})}}
                                        />
                                    }
                                </div>
                                
                                <div className='mt-8'>
                                    <button onClick={()=>{setActiveStep(3)}} className='flex items-center gap-x-2 text-gray-500 hover:text-vcm-purple transition duration-200 mb-3 text-sm'>
                                        <ArrowIcon className={`w-4 h-4 rotate-180`} />
                                        Previous step
                                    </button>
                                    <FormButton buttonLabel={
                                        <span className='flex items-center justify-center gap-x-4'>
                                            Create your account <CheckIcon className={`w-5 h-5`}/>
                                        </span>
                                    } buttonAction={()=>{signup()}} processing={processing} />
                                </div>
                            </div>
                        }
                    </span>}

                    {signupComplete && <span>
                        <div className='w-full text-center'>
                            <div className='flex items-center justify-center'>
                                <CheckBadgeIcon className={`text-purple-500 w-10 h-10 mb-4`} />
                            </div>
                            <h1 className="font-thin text-xs text-primary mb-2 text-opacity-80 tracking-[0.2em] uppercase">thank you</h1>
                            <p>You have signed up successfully</p>
                            <p className='text-sm'>Please check your inbox ({userPayload?.email || ''}) for an email from us. Click the link in the email to continue to your account</p>

                            <div className='p-5'>
                                {counted 
                                    ? 
                                        <button 
                                            className='bg-vcm-purple p-3 rounded-md mt-3 font-medium w-8/12 text-white transition duration-200 hover:bg-opacity-20 text-sm mx-auto flex items-center justify-center' 
                                            onClick={()=>{resendConfirmationEmail()}}
                                        >
                                            {processing ? <InlinePreloader />  : 'Resend confirmation email'}
                                        </button>
                                    :
                                    <>
                                        <p className='py-2mt-2'>Didn&apos;t get the link? please wait <Countdown seconds={60} className='inline text-red-800 font-medium' countdownComplete={()=>{setCounted(true)}} /> seconds
                                        </p>
                                    </>
                                }
                            </div>
                        </div>
                    </span>}

                </div>
        </div>
    )
}

export default Signup